import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { ButtonBase } from '@mui/material'
import { DeleteOutlined, EditOutlined } from '@mui/icons-material'
import { FC } from 'react'
import { Icon } from '@dtx-company/shared-components/src/components/atoms/Icon/index'
import { Stack } from '@dtx-company/design-system/src'
import events from '@dtx-company/inter-app/src/event-tracking/events/flowpage'

export const ManagerSettings: FC<{
  onClickEdit?: () => void
  onClickDelete?: () => void
  dataCy?: string
  disabled: boolean
  viewOnly: boolean
}> = ({ onClickEdit, onClickDelete, disabled, dataCy, viewOnly }) => {
  return (
    <Stack {...(dataCy && { 'data-test': dataCy })} justifyContent="space-between" gap={4}>
      {viewOnly ? (
        <Box height="80px" width="40px" justifyContent="center" alignItems="center">
          <Icon
            width="24px"
            height="24px"
            src="/icons/lock-outline-grey.svg"
            alt="manager locked"
          />
        </Box>
      ) : (
        <>
          <ButtonBase
            disabled={disabled}
            onClick={() => {
              onClickEdit?.()
              events.Flowpage_PageProfile_Clicked_Edit_Link()
            }}
            data-testid="edit-widget-button"
            aria-label="edit link"
          >
            <EditOutlined />
          </ButtonBase>
          <ButtonBase
            disabled={disabled}
            onClick={() => {
              onClickDelete?.()
              events.Flowpage_PageProfile_Clicked_Delete_Link()
            }}
            data-testid="delete-widget-button"
            aria-label="delete link"
          >
            <DeleteOutlined />
          </ButtonBase>
        </>
      )}
    </Stack>
  )
}
